// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2mlXv","footerText":"Footer_footerText__AV5nM"};